"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FabButton", {
  enumerable: true,
  get: function get() {
    return _FabButton["default"];
  }
});
exports["default"] = exports.colors = exports.sizes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./index.css");

var _FabButton = _interopRequireDefault(require("./FabButton"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var sizes = {
  sm: 'px-3 py-2',
  md: 'px-4 py-4',
  lg: 'px-5 py-6'
};
exports.sizes = sizes;
var colors = {
  primary: 'bg-primary hover:bg-primary-active focus:bg-primary-active text-white',
  secondary: 'border hover:bg-secondary text-medium',
  warning: 'bg-red text-white'
};
exports.colors = colors;
var outlinedColors = {
  primary: 'text-primary hover:text-primary-active hover:border-primary-active border-primary border',
  secondary: colors['secondary'],
  warning: 'text-red border-red border'
};

var Button = function Button(_ref, ref) {
  var _ref$outline = _ref.outline,
      outline = _ref$outline === void 0 ? false : _ref$outline,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$rounded = _ref.rounded,
      rounded = _ref$rounded === void 0 ? false : _ref$rounded,
      _ref$plain = _ref.plain,
      plain = _ref$plain === void 0 ? false : _ref$plain,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      children = _ref.children,
      onClick = _ref.onClick,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["outline", "size", "disabled", "active", "rounded", "plain", "className", "color", "children", "onClick", "style"]);
  var colorClass = outline ? outlinedColors[color] : colors[color];
  var sizeClass = sizes[size];
  var classNames = (0, _classnames["default"])('btn', className, colorClass, sizeClass, {
    'outline box-border': outline,
    'plain cursor-pointer': plain,
    'disabled pointer-events-none text-light !border-transparent': disabled,
    '!bg-primary-active': active,
    rounded: rounded
  });

  var props = _objectSpread(_objectSpread({}, rest), {}, {
    className: classNames,
    onClick: !disabled ? onClick : undefined
  });

  return plain ? /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    ref: ref
  }), children) : /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, props, {
    disabled: disabled,
    style: style,
    ref: ref
  }), children);
};

var _default = /*#__PURE__*/(0, _react.forwardRef)(Button);

exports["default"] = _default;
//# sourceMappingURL=index.js.map